import * as React from "react"
import { connect } from "react-redux"
import { IMeta } from "../../reducers/metaReducer"
import * as classNames from "classnames"

interface ILoadingOverlayProps {
    isAsyncRunning?: boolean,
    isSpinnerDisabled?: boolean
}

class LoadingOverlay extends React.Component<ILoadingOverlayProps> {
    constructor(props: ILoadingOverlayProps) {
        super(props)
    }

    public render() {
        const {
            isAsyncRunning,
            isSpinnerDisabled
        } = this.props

        const overlayClass = classNames({
            hidden: !isAsyncRunning || isSpinnerDisabled,
            overlay: true
        })

        const loaderClass = classNames({
            hidden: !isAsyncRunning || isSpinnerDisabled,
            loader: true
        })

        return (
            <div>
                <div className={overlayClass} data-ui-test="spinner-overlay"></div>
                <div className={loaderClass}></div>
            </div>
        )
    }
}

const mapStateToProps = (state: { meta: IMeta }): ILoadingOverlayProps => {
    return {
        isAsyncRunning: state.meta.isAsyncRunning,
        isSpinnerDisabled: state.meta.isSpinnerDisabled
    }
}

export default connect(mapStateToProps)(LoadingOverlay)
